import React from "react";
import {
  Animated,
  PanResponder,
  PixelRatio,
  StyleSheet,
  TouchableOpacity,
  View
} from "react-native";
import fonts from "../constants/fonts";

const REACTIONS = [
  {
    label: "Sangat Buruk",
    src: require("../assets/1a.png"),
    bigSrc: require("../assets/1.png")
  },
  {
    label: "Buruk",
    src: require("../assets/2a.png"),
    bigSrc: require("../assets/2.png")
  },
  {
    label: "Baik",
    src: require("../assets/3a.png"),
    bigSrc: require("../assets/3.png")
  },
  {
    label: "Sangat Baik",
    src: require("../assets/4a.png"),
    bigSrc: require("../assets/4.png")
  }
];
const WIDTH = 320;
const DISTANCE = WIDTH / REACTIONS.length;
const END = WIDTH - DISTANCE;

export default class EmojiRating extends React.Component {
  constructor(props) {
    super(props);

    const s = this.props.selected ? this.props.selected.key : 2;

    this._pan = new Animated.Value(s * DISTANCE);

    this.state = {
      selected: this.props.selected
    };
  }

  UNSAFE_componentWillMount() {
    this._panResponder = PanResponder.create({
      onMoveShouldSetResponderCapture: () => true,
      onMoveShouldSetPanResponderCapture: () => true,
      onPanResponderGrant: (e, gestureState) => {
        this._pan.setOffset(this._pan._value);
        this._pan.setValue(0);
      },
      onPanResponderMove: Animated.event([null, { dx: this._pan }]),
      onPanResponderRelease: () => {
        this._pan.flattenOffset();

        let offset = Math.max(0, this._pan._value + 0);
        if (offset < 0) return this._pan.setValue(0);
        if (offset >= END) {
          this.updatePan(END);

          return this._pan.setValue(offset);
        }

        const modulo = offset % DISTANCE;
        offset =
          modulo >= DISTANCE / 2
            ? offset + (DISTANCE - modulo)
            : offset - modulo;

        this.updatePan(offset);
      }
    });
  }

  updatePan(toValue) {
    this.setState({
      selected: {
        key: toValue / DISTANCE,
        value: REACTIONS[toValue / DISTANCE].label
      }
    });

    this.props.onSelected({
      key: toValue / DISTANCE,
      value: REACTIONS[toValue / DISTANCE].label
    });

    Animated.spring(this._pan, { toValue, friction: 7 }).start();
  }

  render() {
    return (
      <View style={styles.container}>
        <View style={styles.wrap}>
          <View style={styles.line} />

          <View style={styles.reactions}>
            {REACTIONS.map((reaction, idx) => {
              const u = idx * DISTANCE;
              let inputRange = [u - 20, u, u + 20];
              let scaleOutputRange = [1, 0.25, 1];
              let topOutputRange = [0, 10, 0];
              let colorOutputRange = ["#999", "#222", "#999"];

              if (u - 20 < 0) {
                inputRange = [u, u + 20];
                scaleOutputRange = [0.25, 1];
                topOutputRange = [10, 0];
                colorOutputRange = ["#222", "#999"];
              }

              if (u + 20 > END) {
                inputRange = [u - 20, u];
                scaleOutputRange = [1, 0.25];
                topOutputRange = [0, 10];
                colorOutputRange = ["#999", "#222"];
              }

              return (
                <TouchableOpacity
                  onPress={() => this.updatePan(u)}
                  activeOpacity={0.9}
                  key={idx}
                >
                  <View style={styles.smileyWrap}>
                    <Animated.Image
                      source={reaction.src}
                      style={[
                        styles.smiley,
                        {
                          transform: [
                            {
                              scale: this.state.selected
                                ? this._pan.interpolate({
                                    inputRange,
                                    outputRange: scaleOutputRange,
                                    extrapolate: "clamp"
                                  })
                                : 1
                            }
                          ]
                        }
                      ]}
                    />
                  </View>

                  <Animated.Text
                    style={[
                      styles.reactionText,
                      {
                        top: this.state.selected
                          ? this._pan.interpolate({
                              inputRange,
                              outputRange: topOutputRange,
                              extrapolate: "clamp"
                            })
                          : 0,
                        color: this.state.selected
                          ? this._pan.interpolate({
                              inputRange,
                              outputRange: colorOutputRange,
                              extrapolate: "clamp"
                            })
                          : "#999"
                      }
                    ]}
                  >
                    {reaction.label}
                  </Animated.Text>
                </TouchableOpacity>
              );
            })}

            {this.state.selected && (
              <Animated.View
                {...this._panResponder.panHandlers}
                style={[
                  styles.bigSmiley,
                  {
                    transform: [
                      {
                        translateX: this._pan.interpolate({
                          inputRange: [0, END],
                          outputRange: [0, END],
                          extrapolate: "clamp"
                        })
                      }
                    ]
                  }
                ]}
              >
                {REACTIONS.map((reaction, idx) => {
                  let inputRange = [
                    (idx - 1) * DISTANCE,
                    idx * DISTANCE,
                    (idx + 1) * DISTANCE
                  ];
                  let outputRange = [0, 1, 0];

                  if (idx == 0) {
                    inputRange = [idx * DISTANCE, (idx + 1) * DISTANCE];
                    outputRange = [1, 0];
                  }

                  if (idx == REACTIONS.length - 1) {
                    inputRange = [(idx - 1) * DISTANCE, idx * DISTANCE];
                    outputRange = [0, 1];
                  }

                  return (
                    <Animated.Image
                      key={idx}
                      source={reaction.bigSrc}
                      style={[
                        styles.bigSmileyImage,
                        {
                          opacity: this._pan.interpolate({
                            inputRange,
                            outputRange,
                            extrapolate: "clamp"
                          })
                        }
                      ]}
                    />
                  );
                })}
              </Animated.View>
            )}
          </View>
        </View>
      </View>
    );
  }
}

const size = 42;

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    marginTop: 30
  },
  wrap: {
    width: WIDTH
  },
  welcome: {
    fontSize: 18,
    textAlign: "center",
    color: "#777",
    ...fonts.light,
    marginBottom: 50
  },
  reactions: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "transparent"
  },
  smileyWrap: {
    width: DISTANCE,
    height: DISTANCE,
    justifyContent: "center",
    alignItems: "center"
  },
  smiley: {
    width: size,
    height: size,
    borderRadius: size / 2,
    backgroundColor: "#c7ced3"
  },
  bigSmiley: {
    width: DISTANCE,
    height: DISTANCE,
    borderRadius: DISTANCE / 2,
    backgroundColor: "#ffb18d",
    position: "absolute",
    top: 0,
    left: 0
  },
  bigSmileyImage: {
    width: DISTANCE,
    height: DISTANCE,
    position: "absolute",
    top: 0,
    left: 0
  },
  reactionText: {
    fontSize: 12,
    textAlign: "center",
    color: "#999",
    ...fonts.light,
    marginTop: 5
  },
  line: {
    height: 4 / PixelRatio.get(),
    backgroundColor: "#eee",
    width: WIDTH - (DISTANCE - size),
    left: (DISTANCE - size) / 2,
    top: DISTANCE / 2 + 2 / PixelRatio.get()
  }
});
